import { createSlice } from '@reduxjs/toolkit';
import { difference, union } from 'es-toolkit';

import { loadSimilarItemsGroups } from './similarItemsGroups.actions';
import { defaultSimilarItemsGroupsSlice } from './similarItemsGroups.types';

const similarItemsGroupsModuleSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(loadSimilarItemsGroups.pending, (state, { meta }) => {
            state.loading = union(state.loading, [meta.arg]);
        });
        builder.addCase(loadSimilarItemsGroups.fulfilled, (state, { payload }) => {
            const { actionTime, itemId, itemIdList, totalRecords } = payload;
            state.byId[itemId] = itemIdList;
            state.loaded[itemId] = actionTime;
            state.loading = difference(state.loading, [itemId]);
            state.totalRecordsByItemId[itemId] = totalRecords;
        });
        builder.addCase(loadSimilarItemsGroups.rejected, (state, { meta }) => {
            const failedItemId = meta.arg;
            state.loaded[failedItemId] = 0;
            state.loading = difference(state.loading, [failedItemId]);
        });
    },
    initialState: defaultSimilarItemsGroupsSlice,
    name: 'similarItemsGroups',
    reducers: {},
});

export const { reducer: similarItemsGroupsReducer } = similarItemsGroupsModuleSlice;
